<template>
    <b-card>
        <div v-if="$store.state.isTablet" >
            <b-row style="font-weight: bold; text-align: start; margin-bottom:10px">
                <span style="text-align: center;">
                      {{getTitle()}}
                </span>
            </b-row>
            <b-row align-v="end">
                    <year-select @onchange="onYearChange"/>
                    <site-type-select v-if="siteTypes.length" @onchange="onSiteTypeChange"/>
                <b-col>
                    <region-multi-select
                    :selectedRegionId="selectedRegionId"
                    :regions="regions"
                    @oninput="selectedRegionId = ($event) ? ($event).id : null"
                />
                </b-col>
                <b-col>
                    <div style="width: 300px" class="placeholder-color-white">
                        <b-form-input v-model="searchInput" :placeholder="$t('siteSearchPlaceholder')" type="text" class="gray-input" style="margin-left: 10px"/>
                    </div>
                </b-col>
            </b-row>
        </div>   
            <div v-else >
                <b-row align-h="between" class="mt-2 mb-4">
                    <b-col style="font-weight: bold; text-align: start;">
                        <span style="text-align: center;">
                            {{$t('title')}}
                        </span>
                    </b-col>
                    <b-col cols="9" sm="9" md="7" lg="5" xl="6">
                        <b-row align-h="end" no-gutters>
                            <year-select @onchange="onYearChange" style="margin-right: 15px"/>
                            <site-type-select v-if="siteTypes.length" style="margin-right: 20px" @onchange="onSiteTypeChange"/>
                            <region-multi-select
                                :selectedRegionId="selectedRegionId"
                                :regions="regions"
                                @oninput="selectedRegionId = ($event) ? ($event).id : null"
                            />
                            <div style="width: 130px" class="placeholder-color-white">
                                <b-form-input v-model="searchInput" :placeholder="$t('siteSearchPlaceholder')" type="text" class="gray-input" style="margin-left: 10px"/>
                            </div>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        <div class="table-responsive scroll-content mt-3" style="margin-top: 15px;">
            <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em;border-collapse: separate;border-spacing:0;">
                <thead style="position: sticky;background-color: white;top: 0px;z-index:2"> 
                <tr>
                    <th style="width: 10em">{{ $t('site')  }}</th>
                    <th style="width: 10em">{{ $t('openedCount')  }}</th>
                    <th style="width: 10em">{{ $t('totalCount')  }}</th>
                    <th style="width: 10em">{{ $t('lastUpdatingTime')  }}</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="audit in filteredAudits" @click="routeToDocumentDetail(audit)" style="cursor: pointer;">
                        <td style="color: #007bff;">{{audit.name}}</td>
                        <td>{{audit.openedCount}}</td>
                        <td>{{audit.totalCount}}</td>
                        <td v-if="audit.updatedAt">{{audit.updatedAt | formatDate('YYYY-MM-DD') }}</td>
                        <td v-else>-</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </b-card>
</template>

<script>
import _ from 'lodash';
import YearSelect from '../../../components/YearSelect';
import SiteTypeSelect from '../../../components/SiteTypeSelect';
import RegionMultiSelect from '../../../components/RegionMultiSelect';

export default {
    name: 'Audit',
    components: {RegionMultiSelect, SiteTypeSelect, YearSelect},
    data() {
        return {
            searchInput: '',
            tempAudits: [],
            regions: [],
            selectedRegionId: null,
            selectedTypeId: null
        };
    },
    methods: {
        getTitle(){
            if(this.gbId(this.$store.state.user.customerId)){
                return this.$t('garantiTitle');
            }else{
                return this.$t('title');
            }
        },
        onSiteTypeChange(siteTypeId) {
            this.selectedRegionId = null;
            this.selectedTypeId = siteTypeId;
        },
        routeToDocumentDetail(audit) {
            this.$store.state.siteId = audit ? audit.siteId : null;
            /*
            let routeData = this.$router.resolve({
                name: 'ticket-list',
                params: {site_id: audit.siteId},
                query: {start_date: this.year}
            });
            
            if (this.$store.state.user.customerId == 1) {
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({
                    name: 'ticket-list',
                    params: {site_id: audit.siteId},
                    query: {start_date: this.year}
                });
            }
            */
            this.$router.push({
                name: 'ticket-list',
                params: {site_id:  _.get(audit, 'siteId')},
                query: {start_date: this.year}
            });
            return Promise.resolve();
        },
        configureAudit() {
            this.tempAudits = _.map(this.audits, audit => {
                let foundItem = _.find(this.sites, {id: audit.siteId});
                if (foundItem) {
                    return {
                        openedCount: audit.openedAuditCount,
                        totalCount: audit.totalAuditCount,
                        siteId: audit.siteId,
                        code: foundItem.code,
                        siteGroupId: foundItem.siteGroupId,
                        name: foundItem.name,
                        updatedAt: audit.updatedAt
                    };
                } else {
                    return audit;
                }
            });
            return Promise.resolve(true);
        },
        onYearChange(newYear) {
            this.$store.state.year = newYear;
            this.$router.push({
                name: 'audit',
                query: {year: this.year}
            });
            this.$Progress.start();
            this.$store
                .dispatch('getAuditCounts', this.year)
                .then(this.configureAudit)
                .then(() => {
                    this.$Progress.finish();
                });
        }
    },
    computed: {
        filteredAudits() {
            if (this.searchInput.length <= 3) {
                let filteredSites = this.tempAudits.filter(item => {
                    let found = _.find(this.sites, {id: item.siteId});
                    return (
                        this.textStartsWith(item.code + item.name, this.searchInput) &&
                        this.isRegionFound(this.selectedRegionId, item.siteGroupId) &&
                        (!this.selectedTypeId || found.typeId === this.selectedTypeId)
                    );
                });

                if (filteredSites.length) {
                    return filteredSites;
                }
            } else {
                return this.tempAudits.filter(item => {
                    let found = _.find(this.sites, {id: item.siteId});
                    return (
                        this.isSearchTextFound(item.code + item.name, this.searchInput) &&
                        this.isRegionFound(this.selectedRegionId, item.siteGroupId) &&
                        (!this.selectedTypeId || found.typeId === this.selectedTypeId)
                    );
                });
            }
        }
    },
    created() {
        this.regions = [{id: null, display_name: this.$t('allRegions')}, ...this.siteGroups];
        if (this.$store.state.siteId && this.$store.state.redirection) {
            this.$router.push({
                name: 'ticket-list',
                params: {site_id: this.$store.state.siteId},
                query: {start_date: this.year}
            });
        }
        this.$store.state.redirection = false;
        this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.year;
        this.$Progress.start();
        this.$store
            .dispatch('getAuditCounts', this.year)
            .then(this.configureAudit)
            .then(() => {
                this.$Progress.finish();
            });
    }
};
</script>

<style scoped>
</style>

<i18n src="../../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "title": "Düzeltici ve Önleyici Aksiyon Takibi",
            "garantiTitle": "Uygunsuzluk ve Aksiyon Planı",
            "openedCount": "Açık Madde",
            "totalCount": "Toplam Madde",
            "lastUpdatingTime": "Son Güncelleme Tarihi"
        },
        "en": {
            "title": "Corrective and Preventive Action Tracking",
            "garantiTitle": "Corrective and Preventive Action Tracking",
            "openedCount": "Open Items",
            "totalCount": "Total Items",
            "lastUpdatingTime": "Last Update"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Audit/Audits/Audit.vue